<template>
  <div class="logo-container">
    <img class="logo-img" src="../../../assets/images/home/logo@2x.png" />
    <div class="border-div">
      <img src="../../../assets/images/home/img3.png" class="border-img" alt="">
      <van-field clearable :value="value" :border="false" @clear="handleClear" @input="handleInput" class="border-input" placeholder="智能搜索" @keydown.enter.prevent="$emit('search')" />
      <div class="border-btn" @click.stop="$emit('search')">
        <img src="../../../assets/images/home/img4.png" class="icon-search" alt="">
        <span class="btn-txt">搜索</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  methods: {
    handleInput(e) {
      this.$emit('inputChange')
      this.$emit('input', e)
    },
    handleClear() {
      this.$emit('clear')
      this.$emit('input', '')
    }
  }
}
</script>

<style scoped lang="less">
.logo-container {
  height: 48px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 14px;
  box-sizing: border-box;
  margin-bottom: 8px;
  position: fixed;
  background: #fff;
  top: 0;
  left: 0;
  z-index: 999;

  .logo-img {
    width: 24px;
    display: block;
    margin-right: 10px;
  }

  .border-div {
    display: flex;
    align-items: center;
    background: #F9F8F7;
    height: 32px;
    padding: 3px;
    box-sizing: border-box;
    border-radius: 25px;
    flex: 1;

    .border-img {
      width: 34px;
      display: block;
      margin-right: 2px;
      padding-left: 6px;
      box-sizing: border-box;
    }

    .border-input {
      border: none;
      outline: none;
      color: #949BA5;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 13px;
      background-color: transparent;
      flex: 1;
      padding: 0;
      margin-right: 5px;
    }

    .border-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 26px;
      border-radius: 25px;
      background: rgba(213, 207, 201, 0.5);

      .icon-search {
        width: 13px;
        display: block;
        margin-right: 4px;
      }

      .btn-txt {
        color: #000000;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 13px;
      }
    }
  }

  /deep/ .van-search {
    padding: 0;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/SearchHeaderInput.vue